import { ApiResponse } from './../../../core/models/response-api';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environment/environment';
import { Observable } from 'rxjs';
import { CrudService } from '../crud-service/crud.service';

@Injectable({
  providedIn: 'root',
})
export class TestServiceService extends CrudService<ApiResponse<any>, number> {
  public endpointCreateTestWegestu = '/api/TestJob/createTestWegestu';
  public endpoint_skills = '/api/SkillsJob/getByJobOffer';

  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* create test Wegestu */
  CreateTestWegestu(body: {
    sub_category_ids: number[];
    job_offer_id: number;
  }): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + this.endpointCreateTestWegestu,
      body
    );
  }

  createTestEsn(body: any): Observable<ApiResponse<any>> {
      return this._http.post<ApiResponse<any>>(
        `${this._base}/api/TestJob/createTestWithQuestions`,
        body
      );
  }

  /* get skills by id Candidate */
  getSkills(id: any): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + this.endpoint_skills + '?job_offer_id=' + id
    );
  }
   getTestQuestions(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/TestJob/getPassedTestForEsn/${id}`
    );
  }

  /*add question  */
  addQuestion(data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Question_test_jobOffer/add`,
      data
    );
  }

  /*update question  */
  updateQuestion(id: number | undefined, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Question_test_jobOffer/update/${id}`,
      data
    );
  }
  /*update state response  */
  updateStateResponse(id: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/Response_question_test_jobOffer/updateTypeResponseQuestion/${id}`,
      data
    );
  }

  /*delete response  */
  deleteResponse(id: number[]) {
    let ids = '';
    for (const iterator of id) {
      ids += `ids[]=${iterator}&`;
    }
    ids = ids.slice(0, -1);
    return this._http.delete<ApiResponse<any>>(
      this._base + `/api/Response_question_test_jobOffer/delete?${ids}`
    );
  }

  /*delete question category  */
  deleteQesion(id: number) {
    return this._http.delete<ApiResponse<any>>(
      this._base + `/api/Question_test_jobOffer/delete/${id}`
    );
  }

  /*search subCategory  */
  searchQuestionEsnTest(id: number, data: any) {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Question_test_jobOffer/search/${id}`,
      data
    );
  }
}
